var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-down_2",
    d: "M7.81606 8.7998C7.5271 8.7998 7.27024 8.70596 7.0776 8.51828L0.91305 2.51241C0.495658 2.13705 0.495658 1.48016 0.91305 1.10479C1.29833 0.698143 1.97258 0.698143 2.35787 1.10479L7.81606 6.3912L13.2421 1.10479C13.6274 0.698143 14.3017 0.698143 14.687 1.10479C15.1044 1.48016 15.1044 2.13705 14.687 2.51241L8.52241 8.51828C8.32977 8.70596 8.07292 8.7998 7.81606 8.7998Z",
    fill: "#3E4D5A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.0590bac12b56a876b535e42d3c411689.svg";
export { ForwardRef as ReactComponent };